import {linkFragmentToHref} from '@/modules/foundation/sanity/link/query';

import type {NavigationType} from '../../components/Navbar';
import type {SiteSettingsFragment} from '../query';

export function navigationTypeFromSiteSettingsFragment(
	siteSettings: SiteSettingsFragment,
): NavigationType {
	const navigation: NavigationType = [];

	if (!siteSettings.navigation) {
		return navigation;
	}

	for (const item of siteSettings.navigation) {
		if (item._type === 'link') {
			navigation.push({
				type: 'navlink',
				href: linkFragmentToHref(item),
				title: item.title ?? '',
				targetBlank: item.targetBlank,
				_key: item._key,
				featured: item.featured,
			});
		} else if (item._type === 'dropdown') {
			navigation.push({
				type: 'dropdown',
				_key: item._key,
				title: item.title ?? '',
				links:
					item.links?.map((link) => ({
						href: linkFragmentToHref(link),
						title: link.title ?? '',
						targetBlank: link.targetBlank,
						_key: link._key,
						featured: link.featured,
						type: 'navlink',
					})) ?? [],
			});
		}
	}

	return navigation;
}
